module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    })
  }), _vm._v(" "), _c('section', {
    staticClass: "extraHeader"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.extra.title)
    }
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "meta"
  }, [_c('span', [_vm._v(_vm._s(_vm.formattedPubDate))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#comments"
    }
  }, [_vm._v(_vm._s(_vm.comments) + " Comments")])]), _vm._v(" "), _c('p', {
    staticClass: "actions"
  }, [_c('span', [_vm._v("Share\n            "), _c('a', {
    staticClass: "icon",
    attrs: {
      "target": "_blank",
      "href": 'https://twitter.com/home?status=' + encodeURI(_vm.extra.permalink)
    }
  }, [_c('iconify-icon', {
    attrs: {
      "icon": "fa6-brands:twitter"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Twitter")])], 1), _vm._v(" "), _c('a', {
    staticClass: "icon",
    attrs: {
      "target": "_blank",
      "href": 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(_vm.extra.permalink)
    }
  }, [_c('iconify-icon', {
    attrs: {
      "icon": "fa6-brands:facebook-f"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Facebook")])], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08ff5e31"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/extra/Hero.vue
// module id = 762
// module chunks = 1